import '../style/steps-DJbwC-xS.css'
import { defineComponent as g, computed as i, useSlots as G, onBeforeMount as L, provide as z, reactive as k, toRefs as R, watch as B, openBlock as d, createElementBlock as _, normalizeClass as v, renderSlot as y, useCssVars as V, inject as E, onMounted as b, createElementVNode as a, unref as C, createBlock as A, toDisplayString as I, createTextVNode as D, createCommentVNode as M } from "vue";
import { useMobileView as w } from "./hooks/useMobileView.js";
import { BaseSizeEnum as $ } from "./constant/common.js";
import K from "./icon.js";
const O = Symbol("e-steps"), P = Symbol("e-step");
var l = /* @__PURE__ */ ((r) => (r[r.PENDING = 0] = "PENDING", r[r.PROCESSING = 1] = "PROCESSING", r[r.DONE = 2] = "DONE", r))(l || {});
const Y = /* @__PURE__ */ g({
  name: "e-steps",
  __name: "steps",
  props: {
    active: {},
    size: {},
    vertical: { type: Boolean },
    responsive: { type: Boolean }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    const c = r, { isMobile: p } = w(), m = i(() => c.vertical || c.responsive && p.value), N = e, u = G(), h = i(() => {
      const n = ["e-steps"];
      return m.value && n.push("e-steps--vertical", "e-scroller", "e-scroller--fat"), c.size && n.push(`e-steps--${c.size}`), n;
    });
    return L(() => {
      if (typeof u.default == "function") {
        const n = u.default();
        let s = [];
        n.forEach((o) => {
          Array.isArray(o.children) ? s = s.concat(o.children) : (typeof o.type == "string" ? o.type : o.type?.name) === "e-step" && s.push(o);
        });
        const x = s.map((o, f) => f);
        z(P, x);
      }
    }), z(O, k({
      ...R(c),
      vertical: m
    })), B(
      () => c.active,
      (n, s) => {
        N("change", n, s);
      }
    ), (n, s) => (d(), _("ul", {
      class: v(h.value)
    }, [
      y(n.$slots, "default")
    ], 2));
  }
}), j = { class: "e-step__progress" }, T = { key: 1 }, q = {
  key: 0,
  class: "e-step__content"
}, F = { class: "e-step__title" }, H = { class: "e-step__text" }, Z = /* @__PURE__ */ g({
  name: "e-step",
  __name: "step",
  props: {
    title: {},
    text: {},
    reverse: { type: Boolean }
  },
  setup(r) {
    V((t) => ({
      "76fe45a3": x.value
    }));
    const e = k({
      index: -1,
      currentIndex: -1
    }), c = E(P), p = E(O), m = i(() => e.index <= e.currentIndex && e.index !== 0), N = i(() => e.index <= e.currentIndex - 1), u = i(() => e.currentIndex === e.index ? l.PROCESSING : e.currentIndex > e.index ? l.DONE : l.PENDING), h = i(() => u.value === l.DONE), n = i(() => p?.vertical), s = i(() => p?.size), x = i(() => s.value === $.Large ? "48px" : "24px"), o = i(() => s.value === $.Large ? 24 : 16), f = () => {
      e.index = (c ?? []).shift() || 0;
    }, S = (t) => {
      e.currentIndex = t;
    };
    return b(() => {
      f(), B(
        () => p.active,
        (t) => {
          S(t);
        },
        { immediate: !0 }
      );
    }), (t, J) => (d(), _("li", {
      class: v(["e-step", { "e-step--vertical": n.value, [`e-step--${s.value}`]: s.value, "e-step--reverse": t.reverse }])
    }, [
      a("div", j, [
        a("div", {
          class: v(["line", { active: m.value }])
        }, null, 2),
        a("div", {
          class: v(["step-icon", { active: u.value >= C(l).PROCESSING }])
        }, [
          h.value ? (d(), A(C(K), {
            key: 0,
            size: o.value,
            icon: "checkmark"
          }, null, 8, ["size"])) : (d(), _("div", T, I(e.index + 1), 1))
        ], 2),
        a("div", {
          class: v(["line", { active: N.value }])
        }, null, 2)
      ]),
      t.title || t.text || t.$slots.title || t.$slots.text ? (d(), _("div", q, [
        a("div", F, [
          y(t.$slots, "title", {}, () => [
            D(I(t.title), 1)
          ])
        ]),
        a("div", H, [
          y(t.$slots, "text", {}, () => [
            D(I(t.text), 1)
          ])
        ])
      ])) : M("", !0)
    ], 2));
  }
});
export {
  Z as Step,
  Y as Steps
};
//# sourceMappingURL=steps.js.map
